import { ZSP_COMPONENT_LABELS } from '../../../_statics/zspComponent.statics';

/**
 * What to call a Management Liability policy.
 *
 * "ZSP" is an internal product code and means nothing to an insured. The policy
 * is one or more claims-made lines -- D&O, EPL, Fiduciary, Crime -- carried in
 * `componentsGlobalFieldValues`, so the heading names the lines actually bought.
 *
 * Full names read well alone but not in a list, so a combination uses the short
 * forms under a Management Liability heading. With nothing to go on it falls back
 * to the family name, which is at least true.
 */
export const ZSP_SHORT_LABELS: Record<string, string> = {
  ZSP_DNO: 'D&O',
  ZSP_EPL: 'EPL',
  ZSP_FIDUCIARY: 'Fiduciary',
  ZSP_CRIME: 'Crime',
};

export const MANAGEMENT_LIABILITY = 'Management Liability';

/** Codes in a stable order, so the heading does not reshuffle between renders. */
const ORDER = ['ZSP_DNO', 'ZSP_EPL', 'ZSP_FIDUCIARY', 'ZSP_CRIME'];

export function zspProductLabel(components?: Record<string, unknown>): string {
  const codes = ORDER.filter((code) => components?.[code] !== undefined);

  if (codes.length === 0) {
    return `${MANAGEMENT_LIABILITY} Policy`;
  }

  if (codes.length === 1) {
    return ZSP_COMPONENT_LABELS[codes[0]] ?? `${MANAGEMENT_LIABILITY} Policy`;
  }

  const shorts = codes.map((code) => ZSP_SHORT_LABELS[code] ?? code);
  const last = shorts.pop();

  return `${MANAGEMENT_LIABILITY} — ${shorts.join(', ')} and ${last}`;
}
